import React from 'react';
import { Button } from '../Bootstrap';
import classnames from 'classnames';
import './ButtonSelect.scss';

const OptionButton = ({ option, selected, onChange }) => {
  const onClick = () => onChange(option);

  return (
    <Button className={option.toLowerCase() === selected.toLowerCase() ? 'btn-selected' : ''} onClick={onClick}>
      {option}
    </Button>
  );
};

interface ButtonSelectProps<T> {
  selected: T;
  onChange(value: T);
  type: 'button' | 'selector';
  className?: string;
  options: T[];
}

export function ButtonSelect<T>(props: ButtonSelectProps<T>) {
  const { selected, onChange } = props;
  const options = props.options.map((option, i) => (
    <OptionButton option={option} key={i} selected={selected} onChange={onChange} />
  ));

  const className = props.type === 'button' ? 'button-style' : 'selector-style';

  return <div className={classnames('btn-select', props.className, className)}>{options}</div>;
}
